// cart-drawer.js — minimal AJAX cart drawer for Chavena theme.
// Hooks elements with [data-cart-drawer-toggle] / [data-cart-increment] / [data-cart-decrement] / [data-cart-remove].

(function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  // Open / close
  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function toggleDrawer(e) {
    if (e && e.target && e.target.closest('[data-cart-drawer-toggle]')) {
      e.preventDefault();
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    }
  }
  document.addEventListener('click', toggleDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ── Drawer rendering ─────────────────────────────────────────────────────────
  // cart-drawer is a SECTION (sections/cart-drawer.liquid) rendered into every page
  // from layout/theme.liquid. The Cart AJAX API returns its freshly-rendered HTML
  // atomically with each mutation via the `sections` parameter, so the drawer always
  // reflects the just-updated cart without a separate (cacheable) render request.

  // Swap the drawer's inner markup with fresh cart-drawer HTML. Returns false if the
  // HTML did not contain #CartDrawer, so the caller can fall back.
  function renderDrawer(html) {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    if (!fresh) return false;
    drawer.innerHTML = fresh.innerHTML;
    return true;
  }

  // Fallback re-render via a standalone Section Rendering request — only used if a
  // mutation response did not carry the section HTML.
  async function refreshFromServer() {
    try {
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer', { cache: 'no-store' });
      if (!renderDrawer(await res.text())) window.location.reload();
    } catch (err) {
      window.location.reload();
    }
  }

  // Sync the header cart-count badge and notify inline integrations.
  async function updateCartCount() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    // Generic theme hook for inline (theme-embedded) integrations that want to react to
    // cart changes. NOTE: Shopify Web Pixels (e.g. a Meta pixel installed via Customer
    // Events) do NOT receive document events — they listen on Shopify's analytics bus —
    // so this is theme-only and is not a pixel integration point.
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    return cart;
  }

  // Apply a cart mutation response: render the returned section HTML (or fall back),
  // then sync the header count.
  async function applyCartResponse(resp) {
    if (!resp || !resp.sections || !renderDrawer(resp.sections['cart-drawer'])) {
      await refreshFromServer();
    }
    await updateCartCount();
  }

  // ── Line-item controls (increment / decrement / remove) ──────────────────────
  let busy = false;
  drawer.addEventListener('click', async function (e) {
    const item = e.target.closest('[data-line-key]');
    if (!item) return;
    const key = item.dataset.lineKey;
    const qtyEl = item.querySelector('[data-qty]');
    const current = parseInt(qtyEl?.textContent || '1', 10);

    let qty;
    if (e.target.matches('[data-cart-increment]')) qty = current + 1;
    else if (e.target.matches('[data-cart-decrement]')) qty = Math.max(0, current - 1);
    else if (e.target.matches('[data-cart-remove]')) qty = 0;
    else return;

    // Ignore further clicks until this change re-renders, so the next click reads the
    // updated quantity instead of a stale one (change.js sets an absolute quantity).
    if (busy) return;
    busy = true;
    try {
      await applyCartResponse(await update(key, qty));
    } finally {
      busy = false;
    }
  });

  async function update(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      })
    });
    return res.ok ? res.json() : null;
  }

  // ── Add-to-cart via product form ─────────────────────────────────────────────
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[action="/cart/add"], form[action="' + (window.Shopify?.routes?.root || '/') + 'cart/add"]');
    if (!form) return;
    e.preventDefault();
    const data = new FormData(form);
    // Ask the Cart AJAX API to return the re-rendered drawer HTML with the mutation.
    data.append('sections', 'cart-drawer');
    data.append('sections_url', window.location.pathname);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    });
    if (res.ok) {
      await applyCartResponse(await res.json());
      openDrawer();
    } else {
      const err = await res.json();
      alert(err.description || 'Could not add to cart.');
    }
  });

  // ── Cart page line-item controls (uses the same data attributes) ─────────────
  document.querySelectorAll('#cart-form .cart__qty').forEach(function (qty) {
    const input = qty.querySelector('[data-qty-input]');
    qty.querySelector('[data-cart-decrement]')?.addEventListener('click', function () {
      input.value = Math.max(0, parseInt(input.value, 10) - 1);
      input.form.submit();
    });
    qty.querySelector('[data-cart-increment]')?.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
      input.form.submit();
    });
  });
  document.querySelectorAll('#cart-form [data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('[data-line-key]');
      const qty = item.querySelector('[data-qty-input]');
      qty.value = 0;
      qty.form.submit();
    });
  });
})();
